{
  "version": 1,
  "asset_id": "e91e5287-7b24-4068-8bd9-3519acb5206b",
  "project_id": "b3b85082-7610-442f-94fe-f2e293553923",
  "url": "/__l5e/assets-v1/e91e5287-7b24-4068-8bd9-3519acb5206b/chavel-logo-472.webp",
  "r2_key": "a/v1/b3b85082-7610-442f-94fe-f2e293553923/e91e5287-7b24-4068-8bd9-3519acb5206b/chavel-logo-472.webp",
  "original_filename": "chavel-logo-472.webp",
  "size": 18270,
  "content_type": "image/webp",
  "created_at": "2026-08-26T03:51:30Z"
}
